// extracted by mini-css-extract-plugin
module.exports = {"base":"MasonryLayout-module-base","column":"MasonryLayout-module-column"};